<template>
  <div id="comment-field-autocomplete">
    <!-- AJAX BASED AUTOCOMPLETE -->
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="list"
      :searchOn="searchOn"
      :max-suggestions="5"
      :min-length="1"
      :debounce="500"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27]
      }"
      :mode="mode"
      ref="suggestComponent"
      value-attribute="id"
      display-attribute="name"
      @select="onSuggestSelect"
    >
      <div class="g">
        <input type="text" />
      </div>

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>You're searching for '{{ query }}'.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <!-- <div class="misc-item">
              <span>{{ suggestions.length }} suggestions are shown...</span>
            </div>
            <hr> -->
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>No results</span>
        </div>
      </template>

      <div
        slot="suggestion-item"
        slot-scope="scope"
        :title="scope.suggestion.description"
      >
        <div class="text">
          <span v-html="boldenSuggestion(scope)"></span>
        </div>
      </div>

      <div
        class="misc-item"
        slot="misc-item-below"
        slot-scope="{ suggestions }"
        v-if="loading"
      >
        <span>Loading...</span>
      </div>
    </vue-simple-suggest>
  </div>
</template>
<script>
import { boldenMatches } from "@/util/escapeHtml";
import VueSimpleSuggest from "vue-simple-suggest";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import "vue-simple-suggest/dist/styles.css";
import axios from "@/axios.js";

export default {
  props: ["list", "searchOn"],
  name: "ChooseCommentsAutocomplete",
  data() {
    return {
      chosen: "",
      selected: null,
      model: null,
      mode: "input",
      loading: false,
      log: []
    };
  },
  methods: {
    onSuggestSelect(suggest) {
      this.selected = suggest;
        if (this.searchOn == "comment-fields") {
          // moduleCampaignManagement.state.autocomplete_data = suggest;
          this.$emit('selectCommentField' , suggest);
      }

    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      // Release 2 (F2): the name is escaped before the matches are bolded, so a record name
      // can no longer run as HTML, and brackets typed in the search no longer break it.
      return boldenMatches(this.$refs.suggestComponent.displayProperty(suggestion), query);
    }
  },
  mounted() {},
  components: {
    VueSimpleSuggest,
    axios,
    moduleCampaignManagement
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
